class Skybox {
    backgroundTexture;
    static instance;
    constructor(scene, assetLoader) {
        this.backgroundTexture = assetLoader.getSkyboxTexture;
        scene.background = this.backgroundTexture;
    }
    static getInstance(scene, assetLoader) {
        if (!Skybox.instance)
            Skybox.instance = new Skybox(scene, assetLoader);
        return Skybox.instance;
    }
}
export { Skybox };
